import React from 'react';
import PropTypes from 'prop-types';
import { FreeShippingWrapper, MessageContainer } from '../styles/FreeShippingMessage.style';

const FreeShippingMessage = ({ threshold, freeShipsMsg }) => {
  const toSentenceCase = (str) => {
    if (!str) return '';
    const words = str.split(' ');
    if (words.length === 0 || !words[0]) return '';
    return `${words[0][0].toUpperCase()}${words[0].slice(1).toLowerCase()} ${words
      .slice(1)
      .join(' ')}`;
  };

  const message =
    freeShipsMsg && freeShipsMsg.length > 1
      ? `${toSentenceCase(freeShipsMsg[0])}${threshold}${freeShipsMsg[1]?.split(' ')[0]}`
      : '';

  return (
    <FreeShippingWrapper>
      <MessageContainer>{message}</MessageContainer>
    </FreeShippingWrapper>
  );
};

FreeShippingMessage.propTypes = {
  threshold: PropTypes.number,
  freeShipsMsg: PropTypes.arrayOf(PropTypes.string),
};

FreeShippingMessage.defaultProps = {
  threshold: 0,
  freeShipsMsg: [],
};

export default FreeShippingMessage;
